import React, { useState, useContext, useRef } from 'react';
import { ThemeContext } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { useIntl, FormattedMessage } from 'react-intl';

import { useHistory } from 'react-router-dom';
import { DesktopWrapper, DesktopFooter, DesktopMapTitle } from './Styles';
import TiahDealerMapContainer from './TiahDealerMapContainer';
import ROUTES from '../../../components/Routes/constants';
import Header from '../../../_shared/components/Header';

const TiahDealerMap = () => {
  const intl = useIntl();
  const history = useHistory();
  const themeContext = useContext(ThemeContext);
  const mapFilterRef = useRef(null);
  const isMobile = useMediaQuery({
    query: `(max-width: ${themeContext.BP.VDP_MOBILE_WH})`
  });

  const [filterMetaData, setFilterMetaData] = useState({
    hasTradeIn: true,
    isFranchiseDealer: true
  });

  const dismissFilter = () => mapFilterRef?.current?.dismiss();

  return (
    <>
      <Header
        title={intl.formatMessage({ id: 'tiah.map.title' })}
        testId="tiah-delear-map-header"
        onBackClick={() => history.push(ROUTES.TIAH)}
      />
      {!isMobile ? (
        <>
          <DesktopWrapper>
            <DesktopMapTitle>
              <FormattedMessage id="tiah.map.wrapper.title" />
            </DesktopMapTitle>
            <TiahDealerMapContainer
              updateFilter={setFilterMetaData}
              filterMetaData={filterMetaData}
              isMobile={isMobile}
              ref={mapFilterRef}
              onSelectDealer={dismissFilter}
            />
          </DesktopWrapper>
          <DesktopFooter>
            <FormattedMessage
              id="tr5.trademark"
              values={{ year: new Date().getFullYear() }}
            />
          </DesktopFooter>
        </>
      ) : (
        <TiahDealerMapContainer
          updateFilter={setFilterMetaData}
          filterMetaData={filterMetaData}
          isMobile={isMobile}
          ref={mapFilterRef}
          onSelectDealer={dismissFilter}
        />
      )}
    </>
  );
};

export default TiahDealerMap;
